/**
 * Read-only info line shown above the original-data plot once a file is loaded.
 * Displays the file's detected time step and offset (both in minutes), as
 * returned by the anomaly `/load` endpoint.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  filename: string | null;
  timestepMin: number;
  offsetMin: number;
}

const LoadedFileInfo: React.FC<Props> = ({ filename, timestepMin, offsetMin }) => {
  const { t } = useTranslation('dataProcessing');

  // Nothing detected yet (e.g. before load or a single-row file) → render nothing.
  if (!timestepMin) return null;

  return (
    <div className="mt-4 rounded-lg border border-border bg-muted/40 px-4 py-3 text-sm">
      {filename && <div className="font-medium text-foreground">{filename}</div>}
      <div className="text-muted-foreground">
        {t('anomaly.fileInfo.timestep', { value: timestepMin })}
      </div>
      <div className="text-muted-foreground">
        {t('anomaly.fileInfo.offset', { value: offsetMin })}
      </div>
    </div>
  );
};

export default LoadedFileInfo;
